/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  templateUrl: './lti-launch-error.component.html',
  styleUrls: ['./lti-launch-error.component.scss'],
})
export class LtiLaunchErrorComponent implements OnInit {
  reason: string;
  errorTitle: string;
  errorDescription: string;

  private reasonMessages: Record<string, { title: string; description: string }> = {
    test_user_not_supported: {
      title: 'translations.public.lti.launchError.testUserNotSupportedTitle',
      description: 'translations.public.lti.launchError.testUserNotSupportedDescription',
    },
  };

  private defaultMessages = {
    title: 'translations.public.lti.title.error',
    description: 'translations.public.lti.description.LTIRegistration',
  };

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.reason = this.route.snapshot.queryParamMap.get('reason');
    const messages = this.reasonMessages[this.reason] || this.defaultMessages;
    this.errorTitle = messages.title;
    this.errorDescription = messages.description;
  }
}
